import React from 'react'
import PropTypes from 'prop-types'

// kolodny immutability-helper
//   https://github.com/kolodny/immutability-helper
//   npm install --save immutability-helper
import update from 'immutability-helper'

// Material-UI
//   npm install --save material-ui
import TextField from 'material-ui/TextField'

// 自作ユーティリティ・ツール
import * as GridUtils from '../GridUtils'
import * as def from '../define'
import { showMaintenanceDlg } from '../utils'

import { loginInitialRegistration, checkErrorCode } from '../webapi'

/**
 * ログイン
 */
export default class LogIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      info: Object.assign({}, this.props.info),
      errMsg: ''
    }
    this.handleSerialNoChange = this.handleSerialNoChange.bind(this)
    this.handlePhoneNoChange = this.handlePhoneNoChange.bind(this)
    this.btnLoginClick = this.btnLoginClick.bind(this)
    this.handleBtnCancelClick = this.handleBtnCancelClick.bind(this)
  }

  handleSerialNoChange(e) {
    let v = e.target.value
    if (this.state.info.serialNo !== v) {
      this.setState({ info: update(this.state.info, { serialNo: { $set: v } }), errMsg: '' })
    }
  }

  handlePhoneNoChange(e) {
    let v = e.target.value
    if (this.state.info.phoneNo !== v) {
      this.setState({ info: update(this.state.info, { phoneNo: { $set: v } }), errMsg: '' })
    }
  }

  btnLoginClick() {
    // 契約ID 使用済みメッセージの消去
    this.setState({ errMsg: '' })

    // プログレス表示
    if (typeof this.props.callbacks.showMessage === 'function') {
      this.props.callbacks.showMessage('WAIT', {})
    }

    // ログイン
    loginInitialRegistration(this.state.info.serialNo, this.state.info.phoneNo)
      .then(
        function (obj) {
          // 直後に別画面に遷移するので、ここはsetStateを使わず直接変更する
          this.state.info.token = obj.token // eslint-disable-line
          this.state.errMsg = '' // eslint-disable-line
          // サービス種別
          this.state.info.serviceType = obj.serviceType // eslint-disable-line

          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          // 次のステップへ
          if (typeof this.props.callbacks.stepChange === 'function') {
            if (this.state.info.mode === def.MODE.CREATE_TENANT) {
              this.props.callbacks.stepChange(this.state.info, def.STEPS.ENTRY_INPUT)
            } else {
              this.props.callbacks.stepChange(this.state.info, def.STEPS.CONNECT_TENANT)
            }
          }
        }.bind(this)
      ).catch(
        function (err) {
          // プログレス非表示
          if (typeof this.props.callbacks.showMessage === 'function') {
            this.props.callbacks.showMessage('', {})
          }

          if (checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, false)
          } else {
            let msg = ''
            if (err.response.text) {
              let txt = JSON.parse(err.response.text)
              if ('message' in txt) {
                msg = txt.message
              }
            }
            if (msg.length < 1) {
              msg = 'そのシリアルナンバー、電話番号は登録されていません。'
            }
            this.setState({ errMsg: msg })
            document.getElementById('txtSerialNo').focus()
          }
        }.bind(this)
      )
  }

  handleBtnCancelClick() {
    if (typeof this.props.callbacks.stepChange === 'function') {
      this.props.callbacks.stepChange(this.state.info, def.STEPS.MODE_SELECT)
    }
  }

  render() {
    return (
      <div className='AppContent'>
        <div style={{ width: '800px', textAlign: 'left', marginLeft: 'auto', marginRight: 'auto' }}>
          <div className='GroupPane' style={GridUtils.GridColumns('300px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>ログイン</h2>
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(2, 1)} type='text' id='txtSerialNo' floatingLabelText='シリアルNo.' value={this.state.info.serialNo} onChange={this.handleSerialNoChange} />
            <div className='EntryGuidance' style={GridUtils.GridPosStyle(2, 2)}>ライセンス証書に記載されているシリアルNo.を入力してください。</div>
            <TextField className='EntryItem' style={GridUtils.GridPosStyle(3, 1)} type='text' id='txtPhoneNo' floatingLabelText='電話番号' value={this.state.info.phoneNo} onChange={this.handlePhoneNoChange} />
            <div className='EntryGuidance' style={GridUtils.GridPosStyle(3, 2)}>ユーザー登録した電話番号を入力してください。</div>
            <div style={Object.assign(GridUtils.GridPosStyleWithColspan(4, 1, 2), { color: 'red', fontSize: 'medium' })}>{this.state.errMsg}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <button type='button' id='btnLogin' disabled={this.state.info.serialNo.length < 1 || this.state.info.phoneNo.length < 1} onClick={this.btnLoginClick}>ログイン</button>
            <button type='button' id='btnCancel' style={{ margin: '0 40px' }} onClick={this.handleBtnCancelClick}>戻　る</button>
          </div>
        </div>
      </div>
    )
  }
}

LogIn.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/logIn.js